import { Layout, Space, Typography, message } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { LIVE_TYPES } from "../../helpers/constant";
import { getLivesForFan, newLivePublished } from "../../redux/lives/livesSlice";
import { AppDispatch, StoreState } from "../../redux/store";
import FightEventComponent from "../LiveEventComponent/FightEventComponent";
import { FanLivesPageSkelton } from "../SkeltonsComponents/FanLivesPageSkelton";
import FanDiscoverLiveComponent from "./FanDiscoverLiveComponent/FanDiscoverLiveComponent";
import FanLiveWhoLikesItComponent from "./FanLiveWhoLikesItComponent/FanLiveWhoLikesItComponent";
import "./index.less";

const FanLivesSwiper: React.FC<{ activeTabKey: string }> = ({ activeTabKey }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { discoverList: discoverLives, suggestedList: suggestedLives, loading, error, rtmpLive } = useSelector((state: StoreState) => state.lives);

  useEffect(() => {
    if (activeTabKey === LIVE_TYPES.NOW && discoverLives.length === 0 && suggestedLives.length === 0) {
      dispatch(getLivesForFan({ startType: LIVE_TYPES.NOW }));
      dispatch(newLivePublished(false));
    }
  }, [activeTabKey, dispatch]);

  const errorMessage = () => {
    return <>{message.error("live-menu-error")}</>;
  };

  return (
    <Layout className="content livesSwiperWrapper background-transparent">
      {error && errorMessage()}
      {loading ? (
        <FanLivesPageSkelton loading={true} />
      ) : suggestedLives.length !== 0 || discoverLives.length !== 0 || (rtmpLive !== null && rtmpLive?.isStreaming) ? (
        <Space className="gap-1 mb-80" direction="vertical">
          {rtmpLive?.isStreaming && <FightEventComponent isFromNow={true} />}
          {suggestedLives.length !== 0 && <FanLiveWhoLikesItComponent lives={suggestedLives} />}
          {discoverLives.length !== 0 && <FanDiscoverLiveComponent lives={discoverLives} />}
        </Space>
      ) : (
        <Typography.Text className="text-white-color noLivesMessage">{t("no-lives-message")}</Typography.Text>
      )}
    </Layout>
  );
};

export default FanLivesSwiper;
